import React, { useEffect, useState } from "react";
import { Radio, Space, Modal, Pagination, message, Spin } from "antd";
import Layouts from "../../Layouts";
import CommonFilterPatient from "../../Shared/CommonPatientSearch";
import DoctorService from "../../../Services/DoctorService";
import { Tooltip } from "antd"; // Import Tooltip from Ant Design
import AddReferral from "./addReferral";
import PatientQueue from "../VCPage/PatientQueue";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import dayjs from "dayjs";
import PatientService from "../../../Services/PatientService";
import Draggable from "react-draggable";
import { IoIosCloseCircle } from "react-icons/io";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";

function ReferTo() {
  const [loading, setLoading] = useState(true);
  const [referData, setReferData] = useState([]);
  const [radioValue, setRadioValue] = useState("referBy");
  const [modalVisible, setIsModalVisible] = useState(false);
  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    fetchreferData();
  }, [radioValue]);

  const fetchreferData = async () => {
    setLoading(true);
    try {
      let payload = { [radioValue]: loginResultObject.user.userId };
      const response = await DoctorService.referedList(payload);
      setReferData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch patient data:", error);
      setLoading(false);
    }
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value);
  };

  const toggleModal = () => {
    setIsModalVisible(!modalVisible);
  };

  const toggleSearchModal = () => {
    setSearchModalVisible(!searchModalVisible);
  };

  const handlePageChange = (page, size) => {
    const payload = {
      [radioValue]: loginResultObject.user.userId,
      pageNo: page,
      pageSize: size,
    };

    DoctorService.referedList(payload)
      .then((res) => {
        const records = Array.isArray(res?.data?.data) ? res.data.data : [];
        setHasMore(records.length === size);
        setReferData(records);
        setCurrentPage(page);
        setPageSize(size);
      })
      .catch((error) => {
        console.error("Error fetching referral records:", error);
      });
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const [isVerticalOpen, setIsVerticalOpen] = useState(true);

  const handleClick = () => {
    setIsVerticalOpen(true);
  };

  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  return (
    <Layouts>
      <div className="flex flex-col">
        <div className="font-bold">Referral</div>

        {/* ══════════════════════════════════════════
            MOBILE toolbar (hidden on md+)
            Row 1: Radio group
            Row 2: Add Referral button full width
        ══════════════════════════════════════════ */}
        <div className="flex md:hidden flex-col gap-2 mt-3 mb-4">
          <Radio.Group
            className="custom-input"
            onChange={handleRadioChange}
            value={radioValue}
          >
            <Radio className="font-bold" value="referBy">
              Referred To
            </Radio>
            <Radio className="font-bold" value="referTo">
              Referred By
            </Radio>
          </Radio.Group>
          <button
            className="text-white font-semibold p-2 rounded-md w-full"
            onClick={toggleModal}
          >
            Add Referral
          </button>
        </div>

        {/* ══════════════════════════════════════════
            DESKTOP toolbar (hidden on mobile) — UNCHANGED
        ══════════════════════════════════════════ */}
        <Space className="mb-4 mt-4 hidden md:flex justify-between items-center">
          <Radio.Group
            className="custom-input"
            onChange={handleRadioChange}
            value={radioValue}
          >
            <Radio className="font-bold" value="referBy">
              Referred To
            </Radio>
            <Radio className="font-bold" value="referTo">
              Referred By
            </Radio>
          </Radio.Group>
          <button
            className="text-white font-semibold p-2 rounded-md"
            onClick={toggleModal}
          >
            Add Referral
          </button>
        </Space>

        <div className="w-full gap-10">
          {loading ? (
            <div className="flex justify-center items-center mt-40">
              <Spin />
            </div>
          ) : (
            <div className="w-full overflow-x-auto">
              <table className="border w-full table-auto gap-10 border-gray-200 shadow-md rounded-md customTable">
                <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                  <tr>
                    <th className="p-3 whitespace-nowrap">Referral Date</th>
                    <th className="p-3 whitespace-nowrap">Patient</th>
                    <th className="p-3 whitespace-nowrap">
                      {radioValue === "referBy" ? "Doctor" : "Referby Doctor"}
                    </th>
                    <th className="p-3 whitespace-nowrap">Hospital</th>
                    <th className="p-3 whitespace-nowrap">Condition</th>
                    <th className="p-3 whitespace-nowrap">Description</th>
                    <th className="p-3 whitespace-nowrap">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {referData && referData.length > 0 ? (
                    referData.map((record, index) => (
                      <tr
                        key={index}
                        className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                      >
                        <td className="p-3 whitespace-nowrap">
                          {record.referDate}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {record.patientName}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {radioValue === "referBy"
                            ? record.referToName
                            : record.referByName}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {record.referToAccount_Name}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {record.chronicName}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {record.description}
                        </td>
                        <td className="p-3 whitespace-nowrap">
                          {record.appointmentStatus}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4 border">
                        No records found.
                      </td>
                    </tr>
                  )}
                  <div className="flex justify-end items-end my-4"></div>
                </tbody>
              </table>
              <div className="flex justify-end items-end my-4">
                <Pagination
                  align="end"
                  current={currentPage}
                  total={
                    hasMore
                      ? currentPage * pageSize + 1
                      : currentPage * pageSize
                  }
                  pageSize={pageSize}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {modalVisible && (
        <Modal
          title="Refer To"
          open={modalVisible}
          onCancel={toggleModal}
          footer={[]}
          className=""
          width={500}
        >
          <AddReferral
            openPatientSearch={toggleSearchModal}
            onCancel={toggleModal}
          />
        </Modal>
      )}

      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className="cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
              onTouchEnd={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={handleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}

      {isDrawerOpen && <PatientQueue onClose={onClose} />}
    </Layouts>
  );
}

export default ReferTo;
